// texte
import i18next from 'i18next';
import backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import {i18nSupportedLangCodes} from '../../Common/i18nLanguages.js';
import * as Sentry from '@sentry/browser';

// these namespace are needed for jquery-views to access i18n-texts. In our react-world, we don't need to mention any namespaces here
let namespaces = [];

i18next
    // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector) // {load:'languageOnly'}
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        load: 'languageOnly',
        ns: ['common', 'Survey', 'Errors', ...namespaces],
        fallbackNS: 'common',
        fallbackLng: ['en'],
        saveMissing: true, // required for 'missingKeyHandler' to be triggered
        missingKeyHandler: function (lngs, namespace, key) {
            Sentry.captureException(new Error(`Survey - i18n-Translations: Missing key: ${key} (in i18n.${lngs}.${namespace}.json)`));
        },
        supportedLngs: i18nSupportedLangCodes,
        backend: {
            loadPath: '/assets/survey/i18n/{{lng}}/{{ns}}.json'
        },
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        react: {
            useSuspense: true
            // wait        : true
        },
        detection: {
            order: ['htmlTag', 'localStorage', 'path', 'navigator'],
            caches: ['localStorage'],
            lookupFromPathIndex: 1,
            checkWhitelist: false
        }
    });

export const i18n = i18next;